import "./App.css";
import MovieListComponent from "./Component/MovieListComponent";
import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  return (
    <>
      <MovieListComponent />
    </>
  );
}

export default App;
